import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/lib/supabase";
import { clearSessionQueryCache } from "@/lib/queryClient";
import type { LoginFormValues } from "@/schemas/login";

export const useLoginMutation = () => {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async ({ email, password }: LoginFormValues) => {
      const { error } = await supabase.auth.signInWithPassword({
        email,
        password,
      });
      if (error) throw error;
    },
    onSuccess: () => {
      clearSessionQueryCache();
      void navigate("/", { replace: true });
    },
  });
};
